
import apiHandler from './apiHandler'; 


const AmendBooking = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/editBooking',
      method: 'POST',
      data: request,
    });
    if (response.response_code == 200) {
      return response; 
    } else {
      
      throw new Error(response.message || 'Failed to create payment intent');
    }
  } catch (error) {
    console.error("Error creating payment intent:", error);
    throw error; 
  }
};

export default AmendBooking;